<template>
  <el-dialog
    ref="refundTicket"
    title="退票"
    :visible.sync="visible"
    :append-to-body="true"
    width="68%"
  >
    <div class="tipsBox">
      <img style="vertical-align: middle; width: 20px; height: 20px" src="./static/tips.png" />
      <span>
        勾选退票明细，支持修改退款金额，退款后请联系相关人员审核，审核通过后即可退款成功，退款后订单状态变成完全退款！
      </span>
    </div>
    <el-form label-width="88px" :model="form" ref="refundForm" :rules="rules">
      <el-form-item label="退票明细：">
        <el-table
          :data="form.tickets"
          border
          size="mini"
          max-height="300px"
          @selection-change="handleSelectionChange1"
        >
          <el-table-column type="selection" align="center" width="55" />
          <el-table-column label="车票" align="center" prop="ticketTitle" />
          <el-table-column
            label="退款类型"
            align="center"
            prop="intercityOrderRefundType"
            width="110"
          >
            <template slot-scope="scope">
              <div>
                <el-radio v-model="scope.row.intercityOrderRefundType" label="1" size="mini">
                  退款退座
                </el-radio>
                <el-radio
                  v-has-permi="['custom_only_refund']"
                  v-model="scope.row.intercityOrderRefundType"
                  @change="onlyRefund($event, scope.row, scope.$index)"
                  label="2"
                  size="mini"
                  style="margin-right: 30px"
                >
                  仅退款
                </el-radio>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="类型" align="center" prop="ticketType">
            <template slot-scope="scope">
              <div v-if="scope.row.ticketType === 1">座位费</div>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" prop="state">
            <template slot-scope="scope">
              <div v-if="scope.row.state === 1">待支付</div>
              <div v-if="scope.row.state === 2">已支付</div>
              <div v-if="scope.row.state === 3">已取消</div>
              <div v-if="scope.row.state === 4">已退票</div>
            </template>
          </el-table-column>
          <el-table-column label="实付金额" align="center" prop="payAmountYuan" />
          <el-table-column label="已扣退款违约金" align="center" prop="serviceChargeYuan" />
          <el-table-column label="本次退款手续费" align="center" prop="serviceCharge" />
          <el-table-column label="已扣改签违约金" align="center" prop="changeChargeYuan" />
          <el-table-column label="已退金额" align="center" prop="refundedAmountYuan" />
          <el-table-column
            label="本次退款金额"
            align="center"
            prop="refundNowAmountYuan"
            width="134"
          >
            <template slot-scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.refundNowAmountYuan"
                controls-position="right"
                :min="0"
                :max="scope.row.max"
                :precision="2"
                style="width: 7vw"
                @change="inputHandle(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="其他明细：">
        <el-table
          :data="form.others"
          border
          size="mini"
          max-height="300px"
          @selection-change="handleSelectionChange2"
        >
          <el-table-column type="selection" align="center" width="55" :selectable="selectable" />
          <el-table-column label="类型" align="center" prop="type">
            <template slot-scope="scope">
              <div v-if="scope.row.type === 1">接人</div>
              <div v-if="scope.row.type === 2">送人</div>
              <div v-if="scope.row.type === 3">保费</div>
            </template>
          </el-table-column>
          <el-table-column label="退款类型" align="center" prop="ferryOrderRefundType" width="110">
            <template slot-scope="scope">
              <div v-show="scope.row.type !== 3">
                <el-radio v-model="scope.row.ferryOrderRefundType" label="1" size="mini">
                  退款退座
                </el-radio>
                <el-radio
                  v-has-permi="['custom_ferry_refund']"
                  v-model="scope.row.ferryOrderRefundType"
                  label="2"
                  @change="onlyRefund($event, scope.row, scope.$index)"
                  size="mini"
                  style="margin-right: 30px"
                >
                  仅退款
                </el-radio>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="乘客" align="center" prop="paxInfo" />
          <el-table-column label="状态" align="center" prop="state">
            <template slot-scope="scope">
              <span>{{ scope.row | orderStateFilters }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实付金额" align="center" prop="payAmountYuan" />
          <el-table-column label="已扣退款违约金" align="center" prop="serviceChargeYuan" />
          <el-table-column label="本次退款手续费" align="center" prop="serviceCharge" />
          <el-table-column label="已扣改签违约金" align="center" prop="changeChargeYuan" />
          <el-table-column label="已退金额" align="center" prop="refundedAmountYuan" />
          <el-table-column
            label="本次退款金额"
            align="center"
            prop="refundNowAmountYuan"
            width="134"
          >
            <template slot-scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.refundNowAmountYuan"
                controls-position="right"
                :min="0"
                :max="strip(scope.row.payAmountYuan - scope.row.refundedAmountYuan)"
                style="width: 7vw"
                @change="inputHandle(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="退款原因：" prop="refundReason">
        <div style="display: flex">
          <div>
            <el-input
              type="textarea"
              v-model="form.refundReason"
              placeholder="说明，产生退款的实际情况，原因，退还金额的原因等等"
              :rows="4"
              style="width: 28vw"
            />
          </div>
          <div style="display: flex; font-size: 13px; color: #9f9f9f; margin-left: 10px">
            <div>注：</div>
            <div>
              <div style="margin-bottom: -20px">退票退款，表示退款的同时退订单</div>
              <div>仅退款，表示该操作仅退款不退订单，乘客可正常乘车</div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="本次退款金额总计：" label-width="150px">
        <span style="color: #ff4d51">{{ varMatch }} 元</span>
      </el-form-item>
      <!-- <el-form-item label="退票违约金规则：" label-width="150px">
        <el-table :data="refundTicketList" border size="mini" style="width: 30%">
          <el-table-column label="时间" align="center" prop="time" />
          <el-table-column label="退票违约金" width="120" align="center" prop="ticketRule" />
        </el-table>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="cancel">取 消</el-button>
      <el-button v-if="isDisabled" type="primary" size="small" @click="submit">确 定</el-button>
      <el-button v-else disabled type="primary" size="small" @click="submit">确 定</el-button>
    </div>
    <el-dialog
      title="确定仅退款吗？"
      :visible.sync="onlyRefundDialogVisible"
      width="30%"
      center
      append-to-body
      :close-on-click-modal="false"
    >
      <span style="color: red">仅退款表示本次操作仅退款不退订单，乘客依然可正常乘车！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelClick">取 消</el-button>
        <el-button type="primary" @click="sureClick">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import { refundDetail, refundSub } from '@/api/intercityorder'
  import store from '@/store'

  export default {
    name: 'refundTicket',
    /* 保单状态：0,创建；1，待投保；2，投保成功；3，退保成功；4，投保失败;5，已取消；6，投保成功后退票;7,未投保；8，退保失败；9，未投保退票 */
    filters: {
      orderStateFilters(t) {
        let mark = ''
        if (t.type === 3) {
          switch (t.state) {
            case 0:
              mark = '创建'
              break
            case 1:
              mark = '待投保'
              break
            case 2:
              mark = '投保成功'
              break
            case 3:
              mark = '退保成功'
              break
            case 4:
              mark = '投保失败'
              break
            case 5:
              mark = '已取消'
              break
            case 6:
              mark = '投保成功后退票'
              break
            case 7:
              mark = '未投保'
              break
            case 8:
              mark = '退保失败'
              break
            case 9:
              mark = '未投保退票'
              break
          }
        } else {
          switch (t.state) {
            case 1:
              mark = '待支付'
              break
            case 2:
              mark = '待接单'
              break
            case 3:
              mark = '待出发'
              break
            case 4:
              mark = '取消'
              break
            case 5:
              mark = '接人中'
              break
            case 6:
              mark = '待乘客上车'
              break
            case 7:
              mark = '行程中'
              break
            case 8:
              mark = '送达完成'
              break
            case 9:
              mark = '已退款'
              break
            case 10:
              mark = '取消失败'
              break
          }
        }
        return mark
      }
    },
    components: {},
    data() {
      return {
        currentIndex: 0,
        currentTicket: {}, // 当前仅退款选中的票
        onlyRefundDialogVisible: false,
        isDisabled: false,
        visible: false,
        selections1: [],
        selections2: [],
        form: {},
        subForm: {},
        totals1: [],
        totals2: [],
        rules: {
          refundReason: [{ required: true, message: '退款原因不能为空', trigger: 'blur' }]
        },
        refundTicketList: [
          {
            time: '小于1小时',
            ticketRule: '不支持退票'
          },
          {
            time: '1-2小时',
            ticketRule: '30%'
          },
          {
            time: '2-8小时',
            ticketRule: '20%'
          },
          {
            time: '8-12小时',
            ticketRule: '10%'
          },
          {
            time: '大于12小时',
            ticketRule: '0%'
          }
        ],
        tripInfo: {}
        // refundTicketList: [
        //   {
        //     time: '>12小时含12小时',
        //     ticketRule: '0'
        //   },
        //   {
        //     time: '2-12小时含2小时不含12小时',
        //     ticketRule: '20%'
        //   },
        //   {
        //     time: '1-2小时含1小时不含2小时',
        //     ticketRule: '50%'
        //   },
        //   {
        //     time: '<1小时',
        //     ticketRule: '不支持退票'
        //   }
        // ]
      }
    },
    watch: {
      varMatch(val) {
        if (val !== '0.00') {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
        return val
      }
    },
    computed: {
      varMatch() {
        let matchAmount = 0
        this.selections1.forEach((item) => {
          matchAmount += item.refundNowAmountYuan
          return item
        })
        this.selections2.forEach((item) => {
          matchAmount += item.refundNowAmountYuan
        })

        return matchAmount.toFixed(2)
      }
    },
    methods: {
      init(row, data) {
        this.tripInfo = data
        refundDetail(row).then((resp) => {
          this.visible = true
          // if (resp.data && Array.isArray(resp.data.tickets)) {
          //   resp.data.tickets.forEach((it) => {
          //     it.refundNowAmountYuan = 0
          //   })
          // }
          this.form = resp.data
          this.form.tickets.forEach((item) => {
            item.intercityOrderRefundType = '1'
            item.max = (+item.payAmountYuan * 100 - +item.refundedAmountYuan * 100) / 100
            const value = (
              item.payAmountYuan -
              item.serviceChargeYuan -
              item.serviceCharge -
              item.changeChargeYuan -
              item.refundedAmountYuan
            ).toFixed(2)
            item.oldServiceCharge = item.serviceCharge
            this.$set(item, 'refundNowAmountYuan', value)
          })
          this.form.others.forEach((item) => {
            const value = (
              item.payAmountYuan -
              item.serviceChargeYuan -
              item.serviceCharge -
              item.changeChargeYuan -
              item.refundedAmountYuan
            ).toFixed(2)
            item.oldServiceCharge = item.serviceCharge
            this.$set(item, 'refundNowAmountYuan', value)
            if (item.type !== 3) {
              item.ferryOrderRefundType = '1'
            }
          })
        })
      },
      handleSelectionChange1(list1) {
        this.selections1 = list1
      },
      handleSelectionChange2(list2) {
        this.selections2 = list2
      },
      submit() {
        this.$refs.refundForm.validate((valid) => {
          if (valid) {
            this.subForm.orderId = this.form.orderId
            this.subForm.refundReason = this.form.refundReason
            this.subForm.refundAmountYuan = this.varMatch
            // if (this.selections1.length) {
            this.subForm.tickets = this.selections1
            // }
            // if (this.selections2.length) {
            this.subForm.others = this.selections2
            // }
            // 统计手续费相关信息
            // 统计tickets中serviceCharge>0的项
            const ticketFeeList = (this.subForm.tickets || []).filter(
              (item) => Number(item.serviceCharge) > 0
            )
            // 统计others中serviceCharge>0的项
            const otherFeeList = (this.subForm.others || []).filter(
              (item) => Number(item.serviceCharge) > 0
            )
            // 统计总手续费金额
            const totalFee = [...ticketFeeList, ...otherFeeList].reduce(
              (sum, item) => sum + Number(item.serviceCharge),
              0
            )

            // 统计tickets和others的数量
            const ticketCount = ticketFeeList.length
            const otherCount = otherFeeList.length
            // 统计others中有手续费的状态（去重）
            const otherStates = Array.from(
              new Set(
                otherFeeList.map((item) => {
                  // 状态显示用orderStateFilters过滤器
                  return this.$options.filters.orderStateFilters(item)
                })
              )
            ).filter(Boolean)

            let strTip = ''
            if (ticketCount > 0 || otherCount > 0) {
              // 生成提示内容
              const tipArr = []
              // if (ticketCount > 0) tipArr.push(`${ticketCount}个订单`)
              if (otherCount > 0) tipArr.push(`${otherCount}个摆渡订单`)
              const stateStr = otherStates.length > 0 ? `状态为${otherStates.join(',')}` : ''
              strTip = `该订单${
                tipArr.length > 0 ? '关联的摆渡单' + stateStr + '，' : ''
              }将扣除${totalFee.toFixed(2)}元的退款违约金，请确认！`
            }
            // 总退款金额大于0且有手续费才提示
            if (ticketCount > 0 || otherCount > 0) {
              // 有手续费，弹窗提示
              this.$confirm(strTip, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  refundSub(this.subForm).then((resp) => {
                    if (resp.bizCode === 300001) {
                      this.visible = false
                      return
                    }
                    if (resp.code === 0) {
                      this.$message.success('退款已提交，待审核')
                      this.visible = false
                    }
                  })
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  })
                })
            } else {
              // 无手续费，直接提交
              refundSub(this.subForm).then((resp) => {
                if (resp.bizCode === 300001) {
                  this.visible = false
                  return
                }
                if (resp.code === 0) {
                  this.$message.success('退款已提交，待审核')
                  this.visible = false
                }
              })
            }
          } else {
            this.$message.error('退款原因不能为空！')
          }
        })
      },
      cancel() {
        this.visible = false
        this.subForm = {}
      },
      toFixed(number, fractionDigits) {
        // number  保留小数数
        // fractionDigits 保留小数位数
        var times = Math.pow(10, fractionDigits)
        var roundNum = Math.round(number * times) / times
        return roundNum.toFixed(fractionDigits)
      },
      strip(num, precision) {
        if (!precision) {
          precision = 12
        }
        return +parseFloat(num.toPrecision(precision))
      },
      // 提示是否仅退款
      onlyRefund(e, obj, index) {
        this.currentTicket = obj
        this.currentIndex = index
        this.onlyRefundDialogVisible = true
      },
      // 确认仅退款
      sureClick() {
        this.onlyRefundDialogVisible = false
      },
      // 取消仅退款
      cancelClick() {
        this.onlyRefundDialogVisible = false
        if (this.currentTicket.ferryOrderRefundType) {
          this.form.others[this.currentIndex].ferryOrderRefundType = '1'
        } else {
          this.form.tickets[this.currentIndex].intercityOrderRefundType = '1'
        }
      },
      // 判断当前时间超出出发时间，只有平台的人可以退保
      selectable(row, index) {
        const { merchantId } = store.state.user.userInfo
        const { departureDateTime } = this.tripInfo.tripInfo
        if (row.type === 3 && merchantId !== '0' && new Date(departureDateTime) < new Date()) {
          return false
        }
        return true
      },
      inputHandle(e) {
        const value = (
          e.payAmountYuan -
          e.changeChargeYuan -
          e.refundedAmountYuan -
          e.refundNowAmountYuan -
          e.serviceChargeYuan
        ).toFixed(2)
        if (e.oldServiceCharge > value) {
          e.serviceCharge = value > 0 ? value : 0
        } else {
          e.serviceCharge = e.oldServiceCharge
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .el-radio .el-radio__label {
    font-size: 12px !important;
  }
  .tipsBox {
    margin: 0 0 10px 90px;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #9f9f9f;
  }
  .tipsBox span {
    margin-left: 5px;
  }
</style>
